import Link from "next/link"
import {
  Breadcrumb as ShadBreadCrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import React from "react"

type BreadcrumbItem = {
  name: string
  url: string
}

export default function Breadcrumb({
  breadcrumbs,
  currentPage,
}: {
  breadcrumbs?: BreadcrumbItem[]
  currentPage?: string
}) {
  const breadcrumbItems = breadcrumbs?.map((breadcrumb, index) => {
    return (
      <React.Fragment key={index}>
        <BreadcrumbItem key={index}>
          <BreadcrumbLink asChild>
            <Link prefetch={false} href={breadcrumb.url}>
              {breadcrumb.name}
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        {/* Add separators between breadcrumbs. */}
        {index < breadcrumbs.length - 1 && <BreadcrumbSeparator />}
      </React.Fragment>
    )
  })

  return (
    <ShadBreadCrumb className="hidden md:flex min-w-0 max-w-120 lg:max-w-200">
      <BreadcrumbList>
        {breadcrumbItems}
        {breadcrumbs && breadcrumbs.length > 0 && currentPage && (
          <BreadcrumbSeparator />
        )}
        <BreadcrumbItem className="!flex-shrink">
          <BreadcrumbPage>{currentPage}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </ShadBreadCrumb>
  )
}
